// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","logo":"logo__jPF5-","iconTrigger":"iconTrigger__miZgA","iconTriggerItem":"iconTriggerItem__x7TWa","active":"active__r+Z6z","markup":"markup__hBZqq"};